import { render, staticRenderFns } from "./UserRegistrationForm.vue?vue&type=template&id=bfa69b76&scoped=true&"
import script from "./UserRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistrationForm.vue?vue&type=style&index=0&id=bfa69b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa69b76",
  null
  
)

export default component.exports